import { Nullable } from '@internal-libraries/kheops-ui-lib'
import Operation from '../../../../../dPplanningOp/vue/Classes/ClvrOperation'
import { add, parse, format } from 'date-fns'
import { ClvrScreenControlHeaderConfig } from './ClvrScreenControlHeadersEnumRefLabels'

function mappingColumn(name: string, refHeaderLabels: ClvrScreenControlHeaderConfig): Nullable<string> {
    const refSearch = Object.entries(refHeaderLabels).find(([refName, headerConfig]) => {
        return !!headerConfig.children?.[name]
    })
    return undefined !== refSearch ? refSearch[0] : null
}

function mappingStartOperation(data: Operation): string {
    return data.startOperation ?? ''
}

// we do not have an end date of operation we have a start date and a time of operation carried
// out therefore end date = start date of operation + operation time
function mappingEndOperation(data: Operation): string {
    if (!data.startOperation) return ''
    const dateStartOperation = parse(`${data.date} ${data.startOperation}`, 'yyyy-MM-dd HH:mm:ss', new Date())
    if (data.timeOperation) {
        const [hours, minute, second] = data.timeOperation.split(':')
        const dateEndOperation = add(dateStartOperation, {
            hours: hours ? parseInt(hours) : 0,
            minutes: minute ? parseInt(minute) : 0,
            seconds: second ? parseInt(second) : 0,
        })
        return format(dateEndOperation, 'HH:mm:ss')
    }
    return data.startOperation
}

export { mappingColumn, mappingStartOperation, mappingEndOperation }
